<template>
  <div>
    <icu-button @click="files = []">
      Clear
    </icu-button>
    <validation-provider v-slot="{errors}" rules="required">
      <icu-dropzone
        :maximum-files="100"
        :value="files"
        :errors="errors"
        @input="addFile"
      />
    </validation-provider>
  </div>
</template>

<script>
import IcuDropzone from '@/components/inputs/IcuDropzone.vue'
import IcuButton from '@/components/common/IcuButton.vue'
import {ValidationProvider} from 'vee-validate'
import { makePreviewFromImage } from '@/utils.js'

export default {
  name: 'TestPage',
  components: { IcuButton, IcuDropzone, ValidationProvider },
  data() {
    return {
      files: []
    }
  },
  methods: {
    async addFile(file) {
      const fileSrc = await makePreviewFromImage(file)
      
      this.files.push({
        name: file.name,
        src: fileSrc
      })
    }
  }
}
</script>

<style scoped>

</style>
